"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Key = void 0;
/**
 * Incomplete enum for modifier keys used in onKeyDown and onKeyUp
 */
let Key = exports.Key = /*#__PURE__*/function (Key) {
  Key["enter"] = "Enter";
  Key["tab"] = "Tab";
  Key["space"] = " ";
  Key["escape"] = "Escape";
  Key["shift"] = "Shift";
  Key["right"] = "ArrowRight";
  Key["left"] = "ArrowLeft";
  Key["up"] = "ArrowUp";
  Key["down"] = "ArrowDown";
  return Key;
}({});